export const DIALOG_KEYS = {
  AddListingToTourModal: 'AddListingToTourModal',
  OnboardingWelcomeModal: 'OnboardingWelcomeModal',
  SetupBrokerageWizardModal: 'SetupBrokerageWizardModal',
  OnboardingPreLaunchModal: 'OnboardingPreLaunchModal',
  UserSuggestedEmailModal: 'UserSuggestedEmailModal',
  UserSuggestedUpdateModal: 'UserSuggestedUpdateModal',
  FeedbackModal: 'FeedbackModal',
  AppointmentActionModal: 'AppointmentActionModal',
  ContextualChatModal: 'ContextualChatModal',
  LinkAccountModal: 'LinkAccountModal',
} as const;
